import { type AccountingReportAttribute } from '@myre/app-accounting-domain';

import { createAction, props } from '@ngrx/store';

const MODULE_PREFIX = 'accountingReport';

export const getAccountingReportsRequest = createAction(
  `${MODULE_PREFIX}/GET_ACCOUNTING_REPORTS_REQUEST`,
);

export const getAccountingReportsSuccess = createAction(
  `${MODULE_PREFIX}/GET_ACCOUNTING_REPORTS_SUCCESS`,
  props<{ accountingReports: readonly AccountingReportAttribute[] }>(),
);

export const getAccountingReportsError = createAction(
  `${MODULE_PREFIX}/GET_ACCOUNTING_REPORTS_ERROR`,
);

export const downloadAccountingReportRequest = createAction(
  `${MODULE_PREFIX}/DOWNLOAD_ACCOUNTING_REPORT_REQUEST`,
  props<{ batchId: number }>(),
);

export const downloadAccountingReportSuccess = createAction(
  `${MODULE_PREFIX}/DOWNLOAD_ACCOUNTING_REPORT_SUCCESS`,
);

export const downloadAccountingReportError = createAction(
  `${MODULE_PREFIX}/DOWNLOAD_ACCOUNTING_REPORT_ERROR`,
);
